// eslint-disable-next-line no-shadow
enum StatementType {
  REQUEST,
  MANUAL,
}
export default StatementType;
